import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import "../assets/css/App.css";

import Home from "./home";
import Header from "./header";
import Footer from "./Footer";
import Resume from "./resume";
import { LanguageProvider, getPreferredLanguage } from "./LanguageContext";
import { ThemeProvider } from "./ThemeContext";
import { ActiveSectionProvider } from "./ActiveSectionContext";

function LangGate({ children }) {
  const { lang } = useParams();
  if (lang !== "pt" && lang !== "en") {
    return <Navigate to="/pt" replace />;
  }
  return children;
}

function LegacyRedirect({ suffix = "" }) {
  return <Navigate to={`/${getPreferredLanguage()}${suffix}`} replace />;
}

function App() {
  const routes = (
    <Routes>
      <Route path="/" element={<LegacyRedirect />} />
      <Route path="/about" element={<LegacyRedirect suffix="#about" />} />
      <Route path="/projects" element={<LegacyRedirect suffix="#projects" />} />
      <Route path="/resume" element={<LegacyRedirect suffix="/resume" />} />
      <Route
        path="/:lang"
        element={
          <LangGate>
            <Home />
          </LangGate>
        }
      />
      <Route
        path="/:lang/resume"
        element={
          <LangGate>
            <Resume />
          </LangGate>
        }
      />
      <Route path="*" element={<LegacyRedirect />} />
    </Routes>
  );

  return (
    <Router>
      <LanguageProvider>
        <ThemeProvider>
          <ActiveSectionProvider>
            <main>
              <Header />
              {routes}
              <Footer />
            </main>
          </ActiveSectionProvider>
        </ThemeProvider>
      </LanguageProvider>
      <Analytics />
    </Router>
  );
}

export default App;
